import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const InfoIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={12} r={9.5} stroke="currentColor" />
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.5 10.5H12v5M10.5 15.5h3" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.275}
                d="M12 7.625a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75v0"
            />
        </svg>
    </IconWrapper>
)
